import React from 'react';

import Avatar from 'components/Avatar';

import './styles.css';

const SelectOption = ({option, Description}) => (
  <div className="SelectOption">
    <Avatar url={option.url} initials="" />
    <div className="DescriptionContainer">
      {Description && <Description option={option} />}
    </div>
  </div>
);

export default SelectOption;
